<template>
  <section class="home_content">
    <div class="home_carousel">
      <el-carousel indicator-position="outside" :autoplay="false" arrow="always" style="height: 50.3125rem;">
        <el-carousel-item v-for="item of bannerData" :key="item.id" style="height: 50.3125rem;">
          <div class="carousel_img"
            :style="{ 'background-image': 'url(' + item.img + ')', 'background-repeat': 'no-repeat', 'background-size': 'cover' }">
            <div class="carousel_con">
              <h2>{{ item.title }}</h2>
              <div class="englishTitle">
                <div>{{ item.content1 }}</div>
                <div>{{ item.content2 }}</div>
              </div>
              <div class="line"></div>
              <button @click="applyShow">立即申请试用</button>
            </div>
            <div></div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="product" style="padding: 0 7.5rem 2.5rem 7.5rem;min-height: 39.875rem;">
      <div ref="product1" class="product_con">
        <h1>我们的产品服务</h1>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="7">
            <div class="product_zuo">
              <div>
                <div>
                  <div>产品服务</div>
                  <div>PRODUCT SERVICE</div>
                  <div></div>
                </div>
                <div>
                  <div>推动企业</div>
                  <div>采购更加智能、高效、透明</div>
                </div>
              </div>
              <div>
                <!-- <div>查看所有产品<img src="../assets/zu.png" /></div> -->
                <div></div>
              </div>
            </div>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="16">
            <div class="product_you">
              <div v-for="item of productData" :key="item.id">
                <img :src="item.img" />
                <div>
                  <div>
                    <div>{{ item.title }}</div>
                    <div>{{ item.content }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <h1 style="text-align: center;margin-top: 5rem;">我们的糖德商户APP</h1>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="19">
            <div class="product_zuo">
              <div>
                <div>
                  <div>软件介绍</div>
                  <div>APP INTRODUCTION</div>
                  <div></div>
                </div>
                <div>
                  <div style="font-size: 1.2rem;">糖德APP是由厦门鸿宁兴科技有限公司设计与开发的一款商户数字化经营的APP，让传统实体商家通过新兴互联网金融技术实现智慧经营、智能收银、线上开店，帮助商家更好地进行数字化经营转型，助力商家拓展客源、增加销售额。</div>
                </div>
                <div style="margin-top: 2rem;">
                  <div style="font-size: 1.5rem;">软件功能</div>
                </div>
                <div style="font-size: 1rem;">
                  <div style="margin-top: 1.2rem;">1.实时账本功能，交易账单实时显示，账本交易首页即可查看最新收款信息。记账数据折叠汇总，进行统计分析，并同步收款数据，店铺总账一目了然。</div>
                  <div style="margin-top: 1.2rem;">2.用户管理功能，用户精细化管理，商家可在手机端查看用户消费情况、处理用户退款信息。</div>
                  <div style="margin-top: 1.2rem;">3.订单管理功能，通过订单功能，实现对线上订单、线下订单的管理，支持订单接收，方便商户查看、操作订单，实时高效的来对订单进行处理。</div>
                </div>
                <div @click="downlink" style="margin-top: 1.5rem;color: #fff;background: #0e6eb8;display: inline-block;padding: .5rem 1rem;border-radius: 5rem;cursor: pointer;">
                  下载安装
                </div>
              </div>
              <div>
                <!-- <div>查看所有产品<img src="../assets/zu.png" /></div> -->
                <div></div>
              </div>
            </div>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="4">
            <div style="display: flex;justify-content: flex-end;">
              <img style="width: 100%;" src="../assets/home.png" alt="">
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="product bg productFz" style="padding: 5rem 0 2.5rem 7.5rem; display: none;">
      <div ref="product2" class="product_con">
        <h1>我们的服务价值</h1>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="4">
            <div class="product_zuo">
              <div>
                <div>
                  <div>服务价值</div>
                  <div>SERVICE VALUE</div>
                  <div></div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="19">
            <div class="service_you">
              <el-carousel indicator-position="none" arrow="always" :autoplay="false" style="height: 33.3125rem"
                class="carousel_you">
                <el-carousel-item v-for="ite of serviceData2" :key="ite.id" style="height: 33.3125rem"
                  class="carousel_you1">
                  <div class="service_bao">
                    <div v-for="item of ite.valueData2" :key="item.id">
                      <div class="service_con" @mouseenter="onMouseOver2(item)" @mouseleave="onMouseOut2">
                        <div class="service_hover">
                          <img src="../assets/zu38.png" />
                          <div>
                            <span>{{ item.text }}</span>
                            <span></span>
                            <span>{{ item.html }}</span>
                          </div>
                        </div>
                        <div class="service_zhan">
                          <img :src="item.img" />
                          <span>{{ item.text }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="product bg productYs" style="padding: 5rem 0 2.5rem 7.5rem; display: block;">
      <div ref="product2" class="product_con">
        <h1>我们的服务价值</h1>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="4">
            <div class="product_zuo">
              <div>
                <div>
                  <div>服务价值</div>
                  <div>SERVICE VALUE</div>
                  <div></div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="19">
            <div class="service_you">
              <el-carousel indicator-position="none" arrow="always" :autoplay="false" style="height: 33.3125rem"
                class="carousel_you">
                <el-carousel-item v-for="ite of serviceData" :key="ite.id" style="height: 33.3125rem"
                  class="carousel_you1">
                  <div class="service_bao">
                    <div v-for="item of ite.valueData" :key="item.id" @mouseenter="onMouseOver(item,$event)" @mouseleave="onMouseOut(item)">
                      <div class="service_con" >
                        <div class="service_hover" v-if="item.type == '1'">
                          <img src="../assets/zu38.png" />
                          <div>
                            <span>{{ item.text }}</span>
                            <span></span>
                            <span>{{ item.html }}</span>
                          </div>
                        </div>
                        <div class="service_zhan" v-else>
                          <img :src="item.img" />
                          <span>{{ item.text }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="contact_us">
      <div ref="product3" class="us_con">
        <h1 ref="product7">为什么选择我们</h1>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="4">
            <div class="us_zuo">
              <div>选择我们</div>
              <div>CHOOSE US</div>
              <div></div>
            </div>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="19">
            <div class="us_you">
              <div v-for="item of usData" :key="item.id">
                <img :src="item.img" />
                <div>
                  <div>
                    <div>{{ item.title }}</div>
                    <div></div>
                    <div>{{ item.content }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="product">
      <div ref="product4" class="product_con">
        <h1>我们的合作伙伴</h1>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="7">
            <div class="product_zuo">
              <div>
                <div>
                  <div>合作伙伴</div>
                  <div>COOPERATIVE PARTNER</div>
                  <div></div>
                </div>
                <div>
                  <div>与每一种力量</div>
                  <div>共筑智慧、便捷、美好生活</div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="16">
            <div class="cooperation_you">
              <div class="cooperation_box">
                <span></span>
                <span></span>
              </div>
              <el-carousel indicator-position="outside" :autoplay="false" arrow="never"
                style="height: 29.3125rem;overflow:hidden">
                <el-carousel-item v-for="ite of 3" :key="ite.id" style="height: 29.3125rem">
                  <div class="cooperation_con">
                    <div v-for="item of cooperationData" :key="item.id">
                      <img :src="item.img" />
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div class="cooperation_box">
                <span></span>
                <span></span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <SlideBar /> -->
    <ApplyDialog :show.sync="show"></ApplyDialog>

  </section>
</template>

<script>
import SlideBar from "../components/sidebar.vue";
import ApplyDialog from "../components/applyDialog.vue";
export default {
  components: { SlideBar, ApplyDialog },
  data() {
    return {
      show: false,
      isHover: false,
      bannerData: [
        { img: require('../assets/homebg_1.png'), title: '通过提供saas采购数字产品，致力数字化采购 为企业提供采购数字化解决方案', content1: 'PROVIDE ENTERPRISES WITH DIGITAL', content2: 'PROCUREMENT SOLUTIONS' },
        { img: require('../assets/homebg_2.png'), title: '提供自动计算工具，按照企业餐补规则自定义配置，自动计算、发放餐补', content1: 'Customized configuration, automaticcalculation', content2: 'and distribution of meal supplement' },
      ],
      usData: [
        { img: require('../assets/zu37.png'), title: '产品多元化', content: '不同的使用场景提供正地下的信息化解决方案' },
        { img: require('../assets/zu36.png'), title: '更新迭代迅速', content: '根据用户体验及行业发展新动向不断迭代更新产品，保证产品的用户体验以及先进性' },
        { img: require('../assets/zu35.png'), title: '多终端适配', content: 'PC、APP、H5、微信公众号、支付宝小程序、 微信小程序以及智能硬件多端互通' },
        { img: require('../assets/ryjjh.png'), title: '软硬件结合', content: '研发团队具有丰富物联网+的开发经验' },
        { img: require('../assets/zu33.png'), title: '全方位技术支持', content: '1V1专人部署指导,提供操作手册产品手册等文档视频资料,让你快速上手运营' },
        { img: require('../assets/zu34.png'), title: '全天候售后团队', content: '提供6*24小时全班值守快速响应解决技术难题' },
      ],
      productData: [
        { img: require('../assets/slzf.png'), title: '刷脸支付', content: '全面聚合扫码收款,微信支付，支付宝支付，云闪付都能用。实现一码收款，方便快捷省时省力。' },
        { img: require('../assets/sh.png'), title: '商户APP', content: '随时掌握当日的交易情况，集中进行收款交易，查账对账，数据分析，极速提现，资金增值，营销管理等。功能强大，简单易操作' },
        { img: require('../assets/cjewm.png'), title: '超级二维码', content: '融合支付宝，微信支付，银联，百度钱包等多种支付方式，实现一码收款，方便快捷，省时省力' },
        { img: require('../assets/mjjq.png'), title: '门禁机器', content: '门禁的自动化管理，数据还可用于考勤，实现门禁考勤双功能，同时与一卡通系统可以无缝衔接。' },
        { img: require('../assets/pcsyt.png'), title: 'PC收银台', content: '一个多种支付收款工具，无需对接发开，无需更换设备，只需安装一个应用，收款，核销，电子会员一键搞定。' },
        { img: require('../assets/syt.png'), title: '自助闸机', content: '地铁，车站等场所，刷脸识别身份，快速通行' },
      ],
      serviceData: [
        {
          valueData: [
            { type: '1', img: require('../assets/cb.png'), text: '餐补', html: '提供餐补自动计算工具，按照企业餐补规则自定义配置，自动计算餐补金额，在线发放、自动发放餐补。' },
            { type: '0', img: require('../assets/yudingchenggong.png'), text: '在线预定', html: '支持通过小程序进行当天或其他日期的菜品预订，支持餐厅配送或个人自取/组织自取。' },
            { type: '0', img: require('../assets/zhifu-2.png'), text: '员工福利', html: '解决企业餐补多消费场景应用、支持企业的消费、对账、结算、入账等全流程管理，一站式解决大型央国企消费管控繁琐、对账复杂的痛点。' },
            { type: '0', img: require('../assets/yyjk.png'), text: '运营监控', html: '通过电子大屏/移动端可观测食堂运营情况，包括菜品售卖信息、人流量、档口情况、用餐区人员情况、菜品销售排行等信息监测，同时管理者可对食堂整体交易情况、喜好排行、支付方式排行等情况进行监测。' },
          ]
        },
        {
          valueData: [
            { type: '0', img: require('../assets/jzgl.png'), text: '集中管理', html: '支持多餐厅运营、多组织用餐、跨组织、跨区域用餐、统一结算、分别结算等不同管控模式，满足供餐企业、用餐企业、园区企业的集中管控诉求。' },
            { type: '0', img: require('../assets/biaoqianlan_fuli.png'), text: '支付方式', html: '支持用户使用人脸识别、个人餐补账户、组织餐补账户、虚拟账户、二维码、实体卡等方式支付。' },
            { type: '0', img: require('../assets/lsgl.png'), text: '零售管理', html: '支持企业围绕员工生活服务，提供便利店、水果店、休闲吧、咖啡厅、体育馆、干洗店等不同零售场景，以及电商、保险、体检、交通等线上消费场景，使用餐补消费、个人储值消费、卡券消费、企业支付等。' },
            { type: '0', img: require('../assets/dz.png'), text: '对账', html: '支持跨集团、单一集团、单一公司下，跨组织、跨部门消费内部对账；支持微信、支付宝、银行等不同支付渠道的收款对账。' },
          ]
        },
      ],

      serviceData2: [
        {
          valueData2: [
            { type: '1', img: require('../assets/cb.png'), text: '餐补', html: '提供餐补自动计算工具，按照企业餐补规则自定义配置，自动计算餐补金额，在线发放、自动发放餐补。' },
            { type: '0', img: require('../assets/yudingchenggong.png'), text: '在线预定', html: '支持通过小程序进行当天或其他日期的菜品预订，支持餐厅配送或个人自取/组织自取。' },
            { type: '0', img: require('../assets/zhifu-2.png'), text: '员工福利', html: '解决企业餐补多消费场景应用、支持企业的消费、对账、结算、入账等全流程管理，一站式解决大型央国企消费管控繁琐、对账复杂的痛点。' },
          ]
        },
        {
          valueData2: [
            { type: '0', img: require('../assets/yyjk.png'), text: '运营监控', html: '通过电子大屏/移动端可观测食堂运营情况，包括菜品售卖信息、人流量、档口情况、用餐区人员情况、菜品销售排行等信息监测，同时管理者可对食堂整体交易情况、喜好排行、支付方式排行等情况进行监测。' },
            { type: '0', img: require('../assets/jzgl.png'), text: '集中管理', html: '支持多餐厅运营、多组织用餐、跨组织、跨区域用餐、统一结算、分别结算等不同管控模式，满足供餐企业、用餐企业、园区企业的集中管控诉求。' },
            { type: '0', img: require('../assets/biaoqianlan_fuli.png'), text: '支付方式', html: '支持用户使用人脸识别、个人餐补账户、组织餐补账户、虚拟账户、二维码、实体卡等方式支付。' },
          ]
        },
        {
          valueData2: [
            { type: '0', img: require('../assets/lsgl.png'), text: '零售管理', html: '支持企业围绕员工生活服务，提供便利店、水果店、休闲吧、咖啡厅、体育馆、干洗店等不同零售场景，以及电商、保险、体检、交通等线上消费场景，使用餐补消费、个人储值消费、卡券消费、企业支付等。' },
            { type: '0', img: require('../assets/dz.png'), text: '对账', html: '支持跨集团、单一集团、单一公司下，跨组织、跨部门消费内部对账；支持微信、支付宝、银行等不同支付渠道的收款对账。' },
          ]
        },
      ],
      cooperationData: [
        { img: require('../assets/co1.png') },
        { img: require('../assets/co2.png') },
        { img: require('../assets/co3.png') },
        { img: require('../assets/co4.png') },
        { img: require('../assets/co5.png') },
        { img: require('../assets/co6.png') },
        { img: require('../assets/co7.png') },
        { img: require('../assets/co8.png') },
        { img: require('../assets/co9.png') },
        { img: require('../assets/co10.png') },
        { img: require('../assets/co11.png') },
        { img: require('../assets/co12.png') },
      ]
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('scroll', () => {
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if (top > 150) {
        this.$refs.product1?.classList.add('animate__fadeInUp')
        // this.$refs.product1?.classList.add('animate__animated')
      }
      if (top > 750) {
        this.$refs.product2?.classList.add('animate__fadeInUp')
        // this.$refs.product2?.classList.add('animate__animated')
      }
      if (top > 1350) {
        this.$refs.product3?.classList.add('animate__fadeInUp')
        // this.$refs.product3?.classList.add('animate__animated')
      }
      if (top > 1950) {
        this.$refs.product4?.classList.add('animate__fadeInUp')
        // this.$refs.product4?.classList.add('animate__animated')
      }

    })
  },
  methods: {
    // 鼠标移入
    onMouseOver(item,e) {
        // item.type = '1'
        
    },
    // 鼠标移出
    onMouseOut(item) {
        // item.type = '0'
        // this.serviceData.forEach((ele) => {
        //     ele.valueData.forEach((el) => {
        //         el.type = '0'
        //         if(el.type == '0'){
        //             ele.valueData[0].type = '1'
        //         }
        //     })
        // })
    },

    // 鼠标移入
    onMouseOver2(item) {
    //   this.serviceData2.forEach((ele) => {
    //     ele.valueData2.forEach((el) => {
    //       el.type = '0'
    //     })
    //   })
    //   item.type = '1'
    },
    // 鼠标移出
    onMouseOut2() {
    },
    applyShow() {
      this.show = true;
      // 禁止滚动
      this.noScroll()
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    downlink(){
      if(this.isMobile()) {
        if (/Android/.test(navigator.userAgent)) {
        // 处理Android逻辑
        this.down('./static/hnx.apk')
        } else if (/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
        // 处理iOS逻辑
        this.down('https://apps.apple.com/cn/app/%E7%B3%96%E5%BE%B7-%E6%99%BA%E8%83%BD%E7%BB%88%E7%AB%AF/id6450306698')
        }
        console.log(this.isMobile());
      }else{
        this.down('./static/hnx.apk')
      }
    },
    down(val){
      const a = document.createElement('a');
      a.href = val;
      // // 障眼法藏起来a标签
      // a.style.display = 'none';
      // // 将a标签追加到文档对象中
      // document.body.appendChild(a);
      // // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      // a.click();
      // // 一次性的,用完就删除a标签
      // a.remove();
      a.click()
      a.remove()
    }
  }
}
</script>

<style lang="scss" scoped>
.home_content {
  position: relative;
}


.head {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.carousel_con {
  animation: fadenum 2s;
}

@keyframes fadenum {

  0% {
    transform: translateX(-150px);
  }
}

.carousel_img {
  // background: url("../assets/homebg.png") no-repeat center center;
  // background-size: cover;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 7.5rem 2.5rem 7.5rem;
  // height: 50.3125rem;

  .carousel_con {
    display: block;
    width: 48%;

    &>h2 {
      font-size: 2.125rem;
      font-weight: bold;
      color: #333333;
    }

    .englishTitle {
      font-size: .75rem;
      font-weight: 400;
      color: #333333;
      opacity: 0.6;
      margin-top: 3.875rem;
    }

    .line {
      width: 1.875rem;
      height: .25rem;
      background: #0E6EB8;
      margin: 2.5rem 0;
    }

    &>button {
      font-size: 1.25rem;
      font-weight: bold;
      background: none;
      color: #2777b9;
      padding: 1.1875rem 1.9375rem;
      border-radius: .25rem;
      border: .125rem solid #2777b9;
      cursor: pointer;
    }

    &>button:hover {
      background: #0E6EB8;
      color: #ffffff;
      transition: .2s;
    }
  }
}

.el-carousel__button {
  background-color: #0E6EB8;
  width: 2.5rem;
  height: .5rem;
  opacity: 0.2
}

.bg {
  background: #F9F9F9 !important;
}

.productFz {
  // display: none !important;
}

.productYs {
  // display: block !important;
}

.product {
  min-height: 46.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  padding: 1rem 7.5rem 2.5rem 7.5rem;
  // padding: 1rem 0 2.5rem 0;


  .product_con {
    width: 100%;

    &>h1 {
      font-size: 2.5rem;
      font-weight: bold;
      color: #333333;
      text-align: center;
    }

    &>div {
      display: flex;
      // justify-content: center;
      margin-top: 3.75rem;

      .product_zuo {
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        // width: 20%;
        height: 100%;

        &>div:first-child {
          &>div:first-child {

            line-height: 1.875rem;

            &>div:first-child {
              font-size: 1.5rem;
              font-weight: 400;
              color: #333333;
            }

            &>div:nth-child(2) {
              font-size: 1rem;
              font-weight: 400;
              color: #333333;
            }

            &>div:nth-child(3) {
              width: 1.25rem;
              height: .25rem;
              background: #0E6EB8;
              margin-top: .625rem;
            }
          }

          &>div:nth-child(2) {
            font-size: 1.7rem;
            font-weight: bold;
            color: #333333;
            margin-top: 1.625rem;
          }
        }

        &>div:nth-child(2) {
          line-height: 1.625rem;

          &>div:first-child {
            font-size: .875rem;
            font-weight: 400;
            color: #4D4D4D;
            display: flex;
            align-items: center;

            &>img {
              margin-left: .625rem;
            }
          }

          &>div:nth-child(2) {
            width: 20rem;
            height: .125rem;
            background: #333333;
            margin-top: 1rem;
          }
        }
      }

      .product_you {
        display: grid;
        grid-template-rows: repeat(2, 1fr);
        grid-template-columns: repeat(3, 1fr);
        // word-break:break-all;
        // width: 60%;

        &>div {
          // float: left;
          // width: 18.75rem;
          // height: 12.5rem;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;

          &>img {
            width: 100%;
            height: 100%;
          }

          &>div:hover {
            background: rgb(26, 26, 26, 0.3);

            // @keyframes fadenum1 {

            //   0% {
            //     transform: translateX(-50px);
            //   }

            // }

            &>div {
              line-height: 1.625rem;
              justify-content: center;
              text-align: center;
              // animation: fadenum1 2s;

              &>div:first-child {
                color: #FFFFFF;
              }

              &>div:nth-child(2) {
                display: block;
                font-size: 1rem;
                font-weight: 400;
                color: #FFFFFF;
              }
            }

          }

          &>div {
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            &>div {
              width: 90%;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              height: 100%;
              flex-flow: column;

              &>div:first-child {
                font-size: 1.625rem;
                font-weight: 500;
                color: #FFFFFF;
                margin-bottom: 1.25rem;
              }

              &>div:nth-child(2) {
                display: none;
              }
            }
          }
        }
      }

      .service_you {
        // width: 60%;

        @keyframes example {
          0% {
            width: 0%;
            display: none;
            color: #0E6EB8;
          }

          100% {
            width: 100%;
            display: block;
            color: red;
          }
        }

        .service_bao {
          display: flex;
          align-items: center;
          justify-content: center;
          // margin-left: 6.5625rem;

          &>div {
            .service_con {
              // padding-left: 3.625rem;

              .service_zhan {
                // display: none;
              }

              .service_hover {
                // width: 13.5rem;
                // height: 25.25rem;
                width: 20rem;
                transition: width 2s;
                height: 28.125rem;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                // margin: 0 .625rem;
                box-shadow: 0px 0px 2rem 0px rgba(1, 20, 35, 0.08);
                animation-name: example;
                animation-duration: 1s;

                &>img {
                  width: 100%;
                  height: 100%;
                  border-radius: .625rem;
                }

                @keyframes yang12 {
                  0% {
                    opacity: 0
                  }

                  100% {
                    opacity: 1
                  }
                }

                &>div {
                  position: absolute;
                  width: 75%;
                  flex-flow: column;
                  line-height: 1.625rem;
                  animation-name: yang12;
                  animation-duration: 3s;

                  &>span:first-child {
                    font-size: 1.25rem;
                    font-weight: 500;
                    color: #FFFFFF;
                  }

                  &>span:nth-child(2) {
                    width: 3rem;
                    height: .375rem;
                    background: #FFFFFF;
                    display: block;
                    margin: 1.625rem 0;
                  }

                  &>span:nth-child(3) {
                    font-size: .875rem;
                    font-weight: 400;
                    color: #FFFFFF;
                  }
                }
              }
            }

            .service_con {
              // padding-left: 3.45rem;

              .service_hover {
                // display: none;
              }

              .service_hover {
                // width: 13.5rem;
                // height: 25.25rem;
                width: 20rem;
                height: 28.125rem;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                // margin: 0 .625rem;
                box-shadow: 0px 0px 2rem 0px rgba(1, 20, 35, 0.08);
                transition: width 2s;
                // animation-name: example;
                // animation-duration: 1s;


                &>img {
                  width: 100%;
                  height: 100%;
                  border-radius: .625rem;
                }

                &>div {
                  position: absolute;
                  width: 75%;
                  flex-flow: column;
                  line-height: 1.625rem;

                  &>span:first-child {
                    font-size: 1.25rem;
                    font-weight: 500;
                    color: #FFFFFF;
                  }

                  &>span:nth-child(2) {
                    width: 3rem;
                    height: .375rem;
                    background: #FFFFFF;
                    display: block;
                    margin: 1.625rem 0;
                  }

                  &>span:nth-child(3) {
                    font-size: .875rem;
                    font-weight: 400;
                    color: #FFFFFF;
                  }
                }
              }

              .service_zhan {
                // width: 10.875rem;
                // height: 24rem;
                // width: 11.875rem;
                min-width: 9rem;
                height: 28.125rem;
                background: #FFFFFF;
                border: .125rem solid #EEEEEE;
                border-radius: .625rem;
                display: flex;
                justify-content: center;
                flex-flow: column;
                align-items: center;
                margin: 0 .625rem;

                &>img {
                  width: 4.3125rem;
                  height: 4.3125rem;
                }

                &>span {
                  font-size: 1.375rem;
                  font-weight: 500;
                  color: #333333;
                  margin-top: 2.25rem;
                }
              }

            }

          }
        }
      }

      .cooperation_you {
        // width: 60%;

        .cooperation_box {
          display: flex;
          align-items: center;
          justify-content: space-between;

          &>span {
            width: 1rem;
            height: 1rem;
            background: #D4D4D4;
          }
        }

        .cooperation_con {
          display: grid;
          grid-template-rows: repeat(3, 1fr);
          grid-template-columns: repeat(4, 1fr);
          padding-left: 3.75rem;
          padding-top: 2.625rem;

          &>div:hover {
            transform: scale(1.1);
          }

          &>div {
            width: 8rem;
            height: 8rem;
            overflow: hidden;
            position: relative;

            // border: 1px solid red;
            &>img {
              width: 100%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
  }
}

.contact_us {
  background-color: #252F3B;
  min-height: 43.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 7.5rem 2.5rem 7.5rem;
  // padding: 1rem 0 2.5rem 0;

  .us_con {
    width: 100%;

    &>h1 {
      font-size: 2.5rem;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
    }

    .us_zuo {
      display: block;
      line-height: 1.75rem;

      &>div:first-child {
        font-size: 1.5rem;
        font-weight: 400;
        color: #FFFFFF;
      }

      &>div:nth-child(2) {
        font-size: 1rem;
        font-weight: 400;
        color: #FFFFFF;
      }

      &>div:nth-child(3) {
        width: 1.25rem;
        height: .25rem;
        background: #0E6EB8;
        margin-top: .625rem;
      }
    }

    .us_you {
      display: grid;
      grid-template-rows: repeat(2, 1fr);
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 1.25rem;
      // width: 70%;

      &>div {
        // float: left;
        // width: 20.5rem;
        // height: 12.125rem;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 .625rem 1.25rem .625rem;

        &>img {
          width: 100%;
          height: 100%;
        }

        &>div:hover {
          background: rgb(26, 26, 26, 0.3);

          // @keyframes fadenum2 {

          //   0% {
          //     transform: translateY(-15px);
          //   }

          // }

          &>div {
            // animation: fadenum2 2s;

            &>div:first-child {
              color: #FFFFFF;
            }

            &>div:nth-child(2) {
              display: block;
            }

            &>div:nth-child(3) {
              display: block;
            }
          }

        }

        &>div {
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          &>div {
            width: 85%;
            text-align: -webkit-center;
            line-height: 1.625rem;

            &>div:first-child {
              font-size: 1.375rem;
              font-weight: 500;
              color: #333333;
            }

            &>div:nth-child(2) {
              width: 1.25rem;
              height: .1875rem;
              background: #FFFFFF;
              margin: 1rem 0;
              display: none;
            }

            &>div:nth-child(3) {
              font-size: 1rem;
              font-weight: 400;
              color: #FFFFFF;
              display: none;
            }
          }
        }
      }
    }

    &>div {
      display: flex;
      // justify-content: center;
      margin-top: 3.75rem;
    }

  }
}
</style>
<style>
@media screen and (max-width: 600px) {}
</style>
